import { Morpheme } from '@/common/types/scopeAndSequence';
import { getDistinctMorphemes } from '@/common/utils/helpers';
import {
  getCumulativeMorphemes,
  getMorphemesByIds,
} from '@/common/utils/scopeAndSequence';
import { shuffleItems } from '../gameHelpers';

export function getDistractorMorphemes(
  wordMorphemes: Morpheme[],
  level: number,
  distractorCardsEnabled: boolean = true,
): Morpheme[] {
  const NUM_DISTRACTOR_AFFIXES = 2;
  const NUM_DISTRACTOR_BASES = 1;

  // If distractors are disabled, return empty array
  if (!distractorCardsEnabled) {
    return [];
  }

  const cumulativeMorphemeIds = getCumulativeMorphemes(level);
  const cumulativeMorphemes = getMorphemesByIds(cumulativeMorphemeIds);

  const availableMorphemes = cumulativeMorphemes.filter((m) =>
    wordMorphemes.some((wm) => m.spelling !== wm.spelling),
  );
  const distinctMorphemes = getDistinctMorphemes(
    wordMorphemes,
    availableMorphemes,
  );

  const affixes: Morpheme[] = [];
  const bases: Morpheme[] = [];
  for (const morpheme of distinctMorphemes) {
    if (morpheme.type === 'base') bases.push(morpheme);
    else affixes.push(morpheme);
  }

  const distractorMorphemes = [
    ...shuffleItems(affixes).slice(0, NUM_DISTRACTOR_AFFIXES),
    ...shuffleItems(bases).slice(0, NUM_DISTRACTOR_BASES),
  ];

  return shuffleItems(distractorMorphemes);
}
